// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Tostj","notes":"Notes_notes__2eVxz","note":"Notes_note__Xi3Km","markdown":"Notes_markdown__2H47L"};